<template>
  <div class="background">


    <div class="container wizard-width">
      <br>

      <b-row>
        <b-col>

          <!-- Logo -->
          <div class="d-flex ml-3 mt-3 mb-1">
            <img class="logo-login" :src="`${publicUrl}img/logo/eines-logo.svg`" alt />
          </div>

          <!-- / Logo -->

        </b-col>

        <b-col>
          <br />
          <br />

          <small class="text-muted mb-1 mr-1 float-right">Logged in as {{ user.email }} (<b-link @click="logout"
              href="/">Log out</b-link>)</small>

        </b-col>

      </b-row>
      

      <b-card class="container-fluid">
        <h3>Velkommen {{ user.username }}!</h3>
        <h6>Kom i gang ved å legge inn opplysninger i skjemaet nedenfor.</h6>
        <br />

        <!-- Customer og supplier form -->
        <form v-if="showCompany == true && showCompanyError != true">
          <b-form-group>
            <b-form-radio
              v-model="company.type"
              :aria-describedby="ariaDescribedby"
              value="Customer"
            >{{ $t("wizard.customer") }}</b-form-radio>
            <b-form-radio
              v-model="company.type"
              :aria-describedby="ariaDescribedby"
              value="Supplier"
            >{{ $t("wizard.supplier") }}</b-form-radio>
          </b-form-group>

          <!-- Add company number and get details from Bbreg -->
          <label class="mt-1"> {{ $t("wizard.orgnumber") }}</label>
          <b-form
            class="mb-3"
            inline
          >
            <b-form-group>
              <b-input
                v-model="company.orgnumber"
                placeholder="Organisasjonsnummer"
                required
                type="number"
                trim
                no-wheel
              />
            </b-form-group>

            <b-button
              class="ml-3"
              variant="link"
              @click="checkCompany()"
            >Hent opplysninger</b-button>
          </b-form>

          <div v-if="showCompanyDetails == true && showCompanyError != true || showCustomerError != true ">

              <b-form-group :label="$t('wizard.companyname')">
              <b-input
                disabled
                v-model="company.name"
                required
                autofocus
              />
            </b-form-group>

            <b-form-group :label="$t('wizard.address')">
              <b-input
                disabled
                v-model="company.address"
                required
                autofocus
              />
            </b-form-group>

            <b-form-group :label="$t('wizard.postcode')">
              <b-input
                disabled
                v-model="company.postcode"
                required
                autofocus
              />
            </b-form-group>

            <b-form-group :label="$t('wizard.city')">
              <b-input
                disabled
                v-model="company.city"
                required
                autofocus
              />
            </b-form-group>

            <b-form-group :label="$t('wizard.country')">
              <b-input
                disabled
                v-model="company.country"
                required
                autofocus
              />
            </b-form-group>
          </div>
          <br />
        </form>

        <b-alert
              v-if="showUpdateCompany == true"
              show
              variant="secondary"
            >Selskapet er opprettet som kunde. Ønsker du å opprette Minside?</b-alert>

            <b-alert
              v-if="showCreateCompany == true"
              show
              variant="success"
            >Selskapet er tilgjengelig.</b-alert>

            <b-alert
              v-if="showCustomerError == true"
              show
              variant="danger"
            >Selskapet er opprettet som kunde. Vennligst kontakt din administrator for mer informasjon.</b-alert>

            <b-alert
              v-if="showCompanyError == true"
              show
              variant="danger"
            >Selskapet er opprettet som leverandør. Vennligst kontakt din administrator for mer informasjon.</b-alert>



        <b-button
          v-if="showUpdateCompany == true"
          variant="primary"
          @click="updateUser()"
        >Neste
        </b-button>

        <b-button
          v-if="showCreateCompany == true"
          variant="primary"
          @click="createCompany()"
        >Neste</b-button>

        <b-button
          v-if="showDisabledNext == true" 
          variant="outline-primary"
          disabled
        >Neste
        </b-button>

        <b-button
          v-if="showCompanyError == true || showCustomerError == true" 
          variant="primary"
          @click="logout"
        >Tilbake til forsiden</b-button>


        

        <!-- / Add company number and get details from Bbreg -->

        <div v-if="user.customer || showSupplier == true || showCustomer == true">
          <!-- Supplier form -->

          <div v-if="showSupplier == true">
            <b-form-group
              label="Hvilke tjenester ønsker bedriften å tilby?"
              v-slot="{ ariaDescribedby }"
            >
              <b-form-checkbox-group
                v-model="company.services"
                :options="optionsServices"
                :aria-describedby="ariaDescribedby"
                stacked
              ></b-form-checkbox-group>
            </b-form-group>

            <b-form-group label="Generelle vilkår">
              <b-form-textarea
                id="textarea"
                v-model="company.terms"
                placeholder=""
                rows="3"
                max-rows="6"
              ></b-form-textarea>
            </b-form-group>
          </div>

          <!-- / Supplier form -->

          <!-- Customer form -->

          <div v-if="showCustomer == true">
            <h5>Kontaktopplysninger</h5>
            <hr />

            <b-form-group label="Kontaktperson">
              <b-input v-model="company.contact_name" />
            </b-form-group>

            <b-form-group label="E-post">
              <b-input v-model="company.contact_email" />
            </b-form-group>

            <b-form-group label="Telefon">
              <b-input v-model="company.contact_phone" />
            </b-form-group>

            <!-- Invoicemethods -->

            <b-form-group
              label="Fakturametode for leverandører"
              v-slot="{ ariaDescribedby }"
            >

              <b-form-radio
                v-model="company.invoice_method"
                :aria-describedby="ariaDescribedby"
                name="email"
                value="email"
              >E-post</b-form-radio>
              <b-form-radio
                v-model="company.invoice_method"
                :aria-describedby="ariaDescribedby"
                name="ehf"
                value="ehf"
              >EHF</b-form-radio>
              <b-form-radio
                v-model="company.invoice_method"
                :aria-describedby="ariaDescribedby"
                name="invoice"
                value="invoice"
              >Faktura</b-form-radio>

            </b-form-group>

            <b-form-group
              v-if="company.invoice_method == 'email'"
              label="Faktura e-post"
            >
              <b-input
                v-model="company.invoice_email"
                placeholder="E-postadresse"
              />
            </b-form-group>

            <b-form-group
              v-if="company.invoice_method == 'ehf'"
              label="Faktura EHF "
            >
              <b-input
                v-model="company.invoice_ehf"
                placeholder="Organisasjonsnummer"
              />
            </b-form-group>

            <b-form-checkbox
              class="mt-3 mb-3"
              v-if="company.invoice_method == 'invoice'"
              v-model="company.invoice_asaddress"
            >Bruk samme som adresse</b-form-checkbox>

            <b-form-group
              v-if="company.invoice_method == 'invoice'"
              label="Faktura adresse"
            >
              <b-input v-model="company.invoice_address" />
            </b-form-group>

            <b-form-group
              v-if="company.invoice_method == 'invoice'"
              label="Faktura postnummer"
            >
              <b-input v-model="company.invoice_postcode" />
            </b-form-group>

            <b-form-group
              v-if="company.invoice_method == 'invoice'"
              label="Faktura poststed"
            >
              <b-input v-model="company.invoice_city" />
            </b-form-group>
          </div>

          <!-- / Customer form -->

          <b-button
            v-if="showCustomer == true || showSupplier == true"
            variant="primary"
            @click="completeWizard()"
          >Fullfør
          </b-button>
        </div>
      </b-card>
    </div>
  </div>
</template>

<style src="@/vendor/libs/vue-form-wizard/vue-form-wizard.scss" lang="scss"></style>

<script>
import axios from "axios";





export default {
  name: "wizard",
  metaInfo: {
    title: "Wizard",
  },
  components: {
  
    
  },
  data() {
    return {
      user: {},
      company: {
        type: "Customer",
        invoice_method: [],
        mysite: true,
      },
      optionsServices: [
        { text: "Avlusning", value: "delousing" },
        { text: "Brønnbåt", value: "wellboat" },
        { text: "Notspyling", value: "cagecleaning" },
        { text: "Servicearbeid", value: "servicework" },
        { text: "Elektrotjenester", value: "electricalwork" },
      ],
      optionsInvoice: [
        { text: "E-post", value: "email" },
        { text: "EHF", value: "ehf" },
        { text: "Faktura", value: "invoice" },
      ],
      showCompany: true,
      showDisabledNext: true,
      showCompanyDetails: false,
      showSupplier: false,
      showCustomer: false,
      showError: false,
      showCustomerError: false,
      showCompanyError: false,
      showCreateCompany: false,
      showUpdateCompany: false,
      showAlert: false,
      isLoading: false,
      fullPage: true,
    };
  },
  methods: {
    getUser() {
      this.isLoading = true;

      axios
        .get("https://api.eines-as.no/users/me")
        .then((response) => {
          this.user = response.data;

          if (this.user.company != null) {
            this.company = this.user.company;
          }

          this.isLoading = false;
        })
        .catch(function (error) {
          console.log(error);
          this.showError = true;
          this.isLoading = false;
        });
    },
    updateUser() {
      this.showUpdateCompany = false;
      this.showCompany = false;

      this.company.mysite = true

      var userData = {
        company: this.company.id,
        role: "600fe2dc0b7e124b5c5f7f3b",
      };

      axios
        .put("https://api.eines-as.no/users/" + this.user.id, userData)
        .then((response) => {
          this.user = response.data;

          this.company.contact = this.user.username;
          this.company.email = this.user.email;
          this.company.invoice_email = this.user.email;
          this.company.invoice_ehf = this.user.company.orgnumber;
          this.company.invoice_address = this.user.company.address;
          this.company.invoice_postcode = this.user.company.postcode;
          this.company.invoice_city = this.user.company.city;
          this.company.invoice_asaddress = true;

          if (
            this.user.company.type == "Supplier" &&
            this.user.wizard == false
          ) {
            this.showSupplier = true;
          }

          if (
            this.user.company.type == "Customer" &&
            this.user.wizard == false
          ) {
            this.showCustomer = true;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    createCompany() {
      var companyData = this.company;

      axios
        .post("https://api.eines-as.no/companies/", companyData)
        .then((response) => {
          this.company = response.data;
          localStorage.setItem("company", this.company.id);
          this.showCreateCompany = false;
          this.showCompany = false;
          this.updateUser();
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    completeWizard() {
      axios
        .put(
          "https://api.eines-as.no/companies/" + this.company.id,
          this.company
        )
        .then((response) => {
          this.company = response.data;

          this.user.wizard = true;

          axios
            .put("https://api.eines-as.no/users/" + this.user.id, this.user)
            .then((response) => {
              this.user = response.data;

              if (this.user.company.type == "Supplier") {
                this.$router.push("/dashboard/home");
              }

              if (this.user.company.type == "Customer") {
                this.$router.push("/customer/home");
              }
            })
            .catch(function (error) {
              console.log(error);
            });
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    checkCompany() {
      this.isLoading = true;
      this.showCustomerDetails = false;
      this.showCompanyDetails = false;
      this.showUpdateCompany = false;
      this.showCreateCompany = false;

      axios
        .get(
          "https://api.eines-as.no/companies?_where[orgnumber]=" +
            this.company.orgnumber
        )
        .then((response) => {
          if (response.data.length == 0) {
            this.getOrgnumber();
          }

          // If company is customer without mysite
          if (
            response.data.length != 0 &&
            response.data[0].type == "Customer" &&
            response.data[0].mysite == false
          ) {
            this.company = response.data[0];
            localStorage.setItem("company", this.company.id);
            this.showDisabledNext = false;
            this.showCompanyDetails = true;
            this.showUpdateCompany = true;
          }

          // If company is customer with mysite
          if (
            response.data.length != 0 &&
            response.data[0].type == "Customer" &&
            response.data[0].mysite == true

          ) {
            this.showDisabledNext = false;
            this.showCustomerError = true;
          }

          // If company is supplier
          if (
            response.data.length != 0 &&
            response.data[0].type == "Supplier"
          ) {
            this.showDisabledNext = false;
            this.showCompanyError = true;
          } else {
            this.showError = true;
          }

          this.isLoading = false;
        })
        .catch(function (error) {
          console.log(error);
          this.showError = true;
          this.isLoading = false;
        });
    },
    getOrgnumber() {
      this.isLoading = true;
      this.showError = false;
      console.log(this.company);

      axios
        .get(
          "https://data.brreg.no/enhetsregisteret/api/enheter/" +
            this.company.orgnumber
        )
        .then((response) => {
          var companyInfo = {
            name: response.data.navn,
            orgnumber: response.data.organisasjonsnummer,
            address: response.data.forretningsadresse.adresse[0],
            postcode: response.data.forretningsadresse.postnummer,
            city: response.data.forretningsadresse.poststed,
            country: response.data.forretningsadresse.land,
            details: {
              registered: response.data.registreringsdatoEnhetsregisteret,
              employees: response.data.antallAnsatte,
              sector: response.data.naeringskode1.beskrivelse,
            },
            mysite: true,
            type: this.company.type,
          };

          this.company = companyInfo;
          this.showCompanyDetails = true;
          this.showCreateCompany = true;
          this.showDisabledNext = false;
          this.isLoading = false;
        })
        .catch(function (error) {
          console.log(error);
          this.isLoading = false;
        });
    },

    logout: function () {
      this.$store.dispatch("logout").then(() => {
        this.$router.push("/");
      });
    },
  },
  created: function () {
    this.getUser();
  },
};
</script>

<style lang="css" scoped>
body,
html {
  background-color: #801529 !important;
  padding: 0;
  margin: 0;
  width: 100%;
  min-height: 100%;
}

a {
  color: #801529;
  text-decoration: none;
  background-color: transparent;
}

.logo-login {
  width: 215px !important;
}

.wizard-width {
  max-width: 1000px;
}

.element.style {
  border-color: rgb(128, 128, 128);
}
</style>
